class ExtendSectionGlobal extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initCopytext());
    _safeInit(() => this.renderAnnouncementSlider());
    _safeInit(() => this.initDrawer());
    _safeInit(() => this.initFooterMenu());
    _safeInit(() =>
      this.videoMediaPlayOne(
        document.querySelectorAll("video-media:not(.hisong-not-affected)")
      )
    );
    _safeInit(() => this.initScroll());
    _safeInit(() => this.initAnnouncementBarV2());
  }

  initCopytext() {
    const copyableElements = document.querySelectorAll("[copyable]");
    if (!copyableElements.length) return;
    copyableElements.forEach((element) => {
      const contentElement = element.querySelector("[copytext]");
      const copyButton = element.querySelector("[copybutton]");
      copyButton.addEventListener("click", () => {
        const textToCopy = contentElement.textContent;
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => this.showToast("Copy success"))
          .catch((err) => console.error("复制失败:", err));
      });
    });
  }

  showToast(message) {
    const toast = document.createElement("div");
    toast.className = "extend-toast-notification";
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => toast.classList.add("show"), 100);
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  renderAnnouncementSlider() {
    const $sliderWrapper = $(".extend-announcement__slides-wrapper");
    if (!$sliderWrapper.length) return;
    this._registerSectionLoad(
      "announcement_slider",
      "extend_topbar_section",
      "renderAnnouncementSlider"
    );
    const $slider = $(".extend-announcement__slides");
    const $slides = $(".extend-announcement__slide");
    if ($slides.length <= 0) return;

    let sliderInterval = $sliderWrapper.attr("slider-interval");
    let animationSpeed = $sliderWrapper.attr("animation-speed");
    const totalSlides = $slides.length;
    let currentIndex = 0;

    sliderInterval = sliderInterval ? Number(sliderInterval) * 1000 : 5000;
    animationSpeed = animationSpeed ? Number(animationSpeed) * 1000 : 1000;

    function setSlideWidth() {
      const slideWidth = document.documentElement.clientWidth;
      $slides.width(slideWidth);
      $slider.width(totalSlides * slideWidth);
    }
    setSlideWidth();

    setInterval(() => {
      currentIndex = ++currentIndex >= totalSlides ? 0 : currentIndex;
      $slider.animate(
        { left: -(currentIndex * $slides.width()) },
        animationSpeed
      );
    }, sliderInterval);

    $(window).resize(() => {
      setSlideWidth();
      $slider
        .stop(true, true)
        .animate({ left: -(currentIndex * $slides.width()) }, animationSpeed);
    });
  }

  initDrawer() {
    const $shade = $(".extend-drawer-shade");
    if (!$shade.length) return;
    $("[extend-drawer-switch]").click(function () {
      const $this = $(this);
      const drawerAuthority = $this.attr("extend-drawer-authority");
      const drawerContainerId = $this.attr("extend-drawer-container");
      const $drawerContainer = $(`[extend-drawer-id="${drawerContainerId}"]`);
      if ($drawerContainer.length <= 0) return;
      if (drawerAuthority === "open") _openDrawer(drawerContainerId);
      else if (drawerAuthority === "close") _closeDrawer(drawerContainerId);
    });

    function _openDrawer(drawerContainerId) {
      const $drawerContainer = $(`[extend-drawer-id="${drawerContainerId}"]`);
      if (!$drawerContainer) return;
      $("body").addClass("extend-no-scroll");
      $drawerContainer.addClass("open");
      $shade.addClass("show");
      $drawerContainer
        .find(".extend-drawer-close")
        .click(() => _closeDrawer(drawerContainerId));
    }

    function _closeDrawer(drawerContainerId) {
      $("body").removeClass("extend-no-scroll");
      const $drawerContainer = $(`[extend-drawer-id="${drawerContainerId}"]`);
      if (!$drawerContainer) return;
      $drawerContainer.removeClass("open");
      $shade.removeClass("show");
    }
  }

  initFooterMenu() {
    const $footerMenu = $(".extend-footer-menu");
    if (!$footerMenu.length) return;
    this._registerSectionLoad(
      "extend_footer_menu",
      "extend-footer",
      "initFooterMenu"
    );
    $footerMenu.each(function () {
      const $that = $(this);
      $that.find(".extend-footer-menu__swich").on("click", function () {
        if ($that.hasClass("opened")) {
          $that.addClass("closed").removeClass("opened");
        } else {
          $that.addClass("opened").removeClass("closed");
        }
      });
    });
  }

  scrollToHash($container) {
    if (!$container || !window.location.hash) return;
    const target = $(window.location.hash);
    if (!target.length || !$container.length) return;
    setTimeout(() => {
      const scrollTo =
        target.offset().top - $container.offset().top + $container.scrollTop();
      $container.animate({ scrollTop: scrollTo }, 600);
    }, 300);
  }

  async videoMediaPlayOne(elements, prefix = "") {
    if (!elements) elements = [];
    const youtubeIframes = document.querySelectorAll(
      'iframe[type="hisong-youtube-video"]'
    );
    const youtubePlayerList = [];

    if (youtubeIframes.length > 0) {
      await _loadYouTubeSDK();
      youtubeIframes.forEach((iframe, index) => {
        const player = new YT.Player(iframe, {
          events: {
            onStateChange: (event) => {
              if (event.data === YT.PlayerState.PLAYING) {
                _pauseVideo({ youtubeIndex: index });
              }
            },
          },
        });
        youtubePlayerList.push(player);
      });
    }

    if (elements.length > 0) {
      elements.forEach((el, i) =>
        el.setAttribute("extend-id", `${prefix}${i}`)
      );
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "playing"
          ) {
            const videoEl = mutation.target;
            if (videoEl.hasAttribute("playing")) {
              _pauseVideo({
                activeExtendId: videoEl.getAttribute("extend-id"),
              });
            }
          }
        });
      });
      elements.forEach((el) => observer.observe(el, { attributes: true }));
    }

    function _pauseVideo({ activeExtendId, youtubeIndex } = {}) {
      elements.forEach((el) => {
        const extendId = el.getAttribute("extend-id");
        const shouldPause = !activeExtendId || extendId !== activeExtendId;
        if (!shouldPause) return;
        if (el.hasAttribute("loaded")) {
          el.pause();
        }
      });
      youtubePlayerList.forEach((player, index) => {
        if (index !== youtubeIndex) player.pauseVideo();
      });
    }

    window.pauseAllVideo_hisong = _pauseVideo;

    async function _loadYouTubeSDK() {
      if (window.YT?.Player) return;
      await new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://www.youtube.com/iframe_api";
        script.onload = resolve;
        document.head.appendChild(script);
      });
      await new Promise((resolve) => {
        window.onYouTubeIframeAPIReady = resolve;
      });
    }
  }

  initScroll() {
    this._qa("[data-extend-scroll]").forEach((btn) => {
      btn.addEventListener("click", () => {
        this._q(btn.dataset.extendScroll)?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    });
  }

  initAnnouncementBarV2() {
    const _bindSection = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.eabv2Bound === "true") return;

      const wrapper = this._q('[name="eabv2-slides-wrapper"]', sectionEl);
      const track = this._q('[name="eabv2-slides"]', sectionEl);
      const slides = this._qa('[name="eabv2-slide"]', sectionEl);

      if (!wrapper || !track || !slides.length) return;

      sectionEl.dataset.eabv2Bound = "true";

      const intervalValue = Number(wrapper.getAttribute("data-eabv2-interval"));
      const speedValue = Number(
        wrapper.getAttribute("data-eabv2-animation-speed")
      );

      const interval =
        isFinite(intervalValue) && intervalValue > 0
          ? intervalValue * 1000
          : 6000;

      const animationSpeed =
        isFinite(speedValue) && speedValue > 0 ? speedValue * 1000 : 2000;

      const stepDuration = Math.max(interval, animationSpeed + 100);

      let currentIndex = 0;
      let timer = null;

      const _render = () => {
        track.style.setProperty("--eabv2-offset", -(currentIndex * 100) + "%");

        slides.forEach((slide, index) => {
          const isActive = index === currentIndex;

          slide.setAttribute("aria-hidden", isActive ? "false" : "true");

          const link = this._q("a", slide);

          if (link) {
            if (isActive) {
              link.removeAttribute("tabindex");
            } else {
              link.setAttribute("tabindex", "-1");
            }
          }
        });
      };

      const _stop = () => {
        if (timer !== null) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const _destroy = () => {
        _stop();

        document.removeEventListener("shopify:section:unload", _onUnload);

        sectionEl.removeEventListener("focusin", _onFocusIn);

        sectionEl.removeEventListener("focusout", _onFocusOut);

        delete sectionEl.dataset.eabv2Bound;
      };

      const _start = () => {
        _stop();

        if (slides.length <= 1) return;

        timer = window.setInterval(() => {
          if (!sectionEl.isConnected) {
            _destroy();
            return;
          }

          currentIndex = (currentIndex + 1) % slides.length;
          _render();
        }, stepDuration);
      };

      const _onFocusIn = () => {
        _stop();
      };

      const _onFocusOut = (event) => {
        if (event.relatedTarget && sectionEl.contains(event.relatedTarget)) {
          return;
        }

        _start();
      };

      const _onUnload = (event) => {
        const target = event.target;

        if (
          target === sectionEl ||
          (target && target.contains && target.contains(sectionEl))
        ) {
          _destroy();
        }
      };

      track.style.setProperty("--eabv2-animation-speed", animationSpeed + "ms");

      _render();
      _start();

      sectionEl.addEventListener("focusin", _onFocusIn);

      sectionEl.addEventListener("focusout", _onFocusOut);

      document.addEventListener("shopify:section:unload", _onUnload);
    };

    this._registerSectionLoad({
      key: "announcementBarV2",
      className: "extend-announcement-bar-v2",
      onLoad: (sectionEl) => {
        _bindSection(sectionEl);
      },
    });

    this._qa(".extend-announcement-bar-v2").forEach((sectionEl) => {
      _bindSection(sectionEl);
    });
  }
}
